var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { getRootLogger } from '@lucidlink/tscore';
import { LOGIN_WIZARD_STEPS } from '#constants';
export const useGetAuthCodeHandler = ({ exchangeCode, handleGeneralLoginError, loginEmail, setAccessToken, setNextStep, }) => {
    _react_refresh_temp_1();
    return useCallback(async (message) => {
        if (message.type !== 'auth-code-received') {
            return;
        }
        try {
            const tokenEndpointResponse = await exchangeCode(message.payload);
            if (!tokenEndpointResponse?.access_token) {
                getRootLogger().warn({ email: loginEmail }, 'Sso auth code exchange returned no access token');
                return;
            }
            if (tokenEndpointResponse.access_token) {
                setAccessToken(tokenEndpointResponse.access_token);
                setNextStep(LOGIN_WIZARD_STEPS.SSO_KEY);
            }
        }
        catch (error) {
            getRootLogger().error({ err: error, email: loginEmail }, 'Sso auth code exchange failed');
            handleGeneralLoginError();
        }
    }, [
        exchangeCode,
        handleGeneralLoginError,
        loginEmail,
        setAccessToken,
        setNextStep,
    ]);
};
_react_refresh_temp_1(useGetAuthCodeHandler, "epj4qY15NHsef74wNqHIp5fdZmg=");
